import React from 'react';
import { IntegrationProps } from '../types';

export const GenericWhatsappSettings: React.FC<IntegrationProps> = ({ config, onChange }) => {
  return (
    <div className="space-y-4 animate-in fade-in">
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">Provider API URL</label>
        <input
          type="text"
          value={config.apiUrl || ''}
          onChange={(e) => onChange({ apiUrl: e.target.value })}
          className="w-full p-2 border rounded-lg"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-slate-700 mb-1">Auth Token</label>
        <input
          type="password"
          value={config.authToken || ''}
          onChange={(e) => onChange({ authToken: e.target.value })}
          className="w-full p-2 border rounded-lg"
        />
      </div>
    </div>
  );
};